import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SuggestedPublicationsPicker"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/home/(feed)/components/SuggestedPublicationsPicker.tsx");
